export default "__VITE_ASSET__CcprX_aN__"